export default "__VITE_ASSET__5e317007__"